import { ButtonSpinner } from '../components/ButtonSpinner'
import { InquirySelectField, InquiryTextField } from '../components/InquiryFields'
import { InquiryFormLayout } from '../components/InquiryFormLayout'
import {
  INDIA_STATE_OPTIONS,
  INQUIRY_COUNTRIES,
  VENDOR_REGISTRATION_COPY,
} from '../constants/inquiries'
import { useVendorRegistrationForm } from '../hooks/useVendorRegistrationForm'
import '../styles/inquiry-page.scss'

export function VendorRegistrationPage() {
  const { form, update, submitting, submitted, error, onSubmit } =
    useVendorRegistrationForm()
  const fields = VENDOR_REGISTRATION_COPY.fields

  return (
    <InquiryFormLayout
      variant="vendor"
      eyebrow={VENDOR_REGISTRATION_COPY.eyebrow}
      title={VENDOR_REGISTRATION_COPY.title}
      lead={VENDOR_REGISTRATION_COPY.lead}
      highlights={VENDOR_REGISTRATION_COPY.highlights}
    >
      {submitted ? (
        <p className="inquiry-success" role="status">
          {VENDOR_REGISTRATION_COPY.success}
        </p>
      ) : (
        <form className="inquiry-form inquiry-form--sections" onSubmit={onSubmit}>
          <section className="inquiry-section">
            <h3>
              <span>1</span>
              {VENDOR_REGISTRATION_COPY.sections.details}
            </h3>
            <div className="inquiry-section__grid">
              <InquiryTextField
                id="vendor-first-name"
                label={fields.firstName.label}
                placeholder={fields.firstName.placeholder}
                value={form.firstName}
                required
                autoComplete="given-name"
                disabled={submitting}
                onChange={(firstName) => update({ firstName })}
              />
              <InquiryTextField
                id="vendor-last-name"
                label={fields.lastName.label}
                placeholder={fields.lastName.placeholder}
                value={form.lastName}
                required
                autoComplete="family-name"
                disabled={submitting}
                onChange={(lastName) => update({ lastName })}
              />
              <InquiryTextField
                id="vendor-email"
                label={fields.email.label}
                type="email"
                placeholder={fields.email.placeholder}
                value={form.email}
                required
                autoComplete="email"
                disabled={submitting}
                onChange={(email) => update({ email })}
              />
              <InquiryTextField
                id="vendor-username"
                label={fields.username.label}
                placeholder={fields.username.placeholder}
                value={form.username}
                required
                autoComplete="username"
                disabled={submitting}
                onChange={(username) => update({ username })}
              />
            </div>
          </section>

          <section className="inquiry-section">
            <h3>
              <span>2</span>
              {VENDOR_REGISTRATION_COPY.sections.store}
            </h3>
            <div className="inquiry-section__grid">
              <InquiryTextField
                id="vendor-store-name"
                label={fields.storeName.label}
                placeholder={fields.storeName.placeholder}
                value={form.storeName}
                required
                autoComplete="organization"
                disabled={submitting}
                onChange={(storeName) => update({ storeName })}
              />
              <InquiryTextField
                id="vendor-phone"
                label={fields.storePhone.label}
                type="tel"
                placeholder={fields.storePhone.placeholder}
                value={form.storePhone}
                required
                autoComplete="tel"
                disabled={submitting}
                onChange={(storePhone) => update({ storePhone })}
              />
            </div>
          </section>

          <section className="inquiry-section">
            <h3>
              <span>3</span>
              {VENDOR_REGISTRATION_COPY.sections.address}
            </h3>
            <InquiryTextField
              id="vendor-address-1"
              label={fields.address1.label}
              placeholder={fields.address1.placeholder}
              value={form.address1}
              required
              autoComplete="address-line1"
              disabled={submitting}
              onChange={(address1) => update({ address1 })}
            />
            <InquiryTextField
              id="vendor-address-2"
              label={fields.address2.label}
              placeholder={fields.address2.placeholder}
              value={form.address2}
              autoComplete="address-line2"
              disabled={submitting}
              onChange={(address2) => update({ address2 })}
            />
            <div className="inquiry-section__grid">
              <InquiryTextField
                id="vendor-city"
                label={fields.city.label}
                placeholder={fields.city.placeholder}
                value={form.city}
                autoComplete="address-level2"
                disabled={submitting}
                onChange={(city) => update({ city })}
              />
              <InquirySelectField
                id="vendor-state"
                label={fields.state.label}
                value={form.state}
                required
                placeholder={fields.state.placeholder}
                options={INDIA_STATE_OPTIONS}
                disabled={submitting}
                onChange={(state) => update({ state })}
              />
              <InquirySelectField
                id="vendor-country"
                label={fields.country.label}
                value={form.country}
                required
                options={INQUIRY_COUNTRIES}
                disabled={submitting}
                onChange={(country) => update({ country })}
              />
              <InquiryTextField
                id="vendor-postcode"
                label={fields.postcode.label}
                placeholder={fields.postcode.placeholder}
                value={form.postcode}
                required
                autoComplete="postal-code"
                disabled={submitting}
                onChange={(postcode) => update({ postcode })}
              />
            </div>
            <div className="inquiry-form__footer">
              <p className="inquiry-note">{VENDOR_REGISTRATION_COPY.note}</p>
              <button type="submit" className="inquiry-submit" disabled={submitting}>
                {submitting ? (
                  <ButtonSpinner label={VENDOR_REGISTRATION_COPY.submit} />
                ) : (
                  VENDOR_REGISTRATION_COPY.submit
                )}
              </button>
            </div>
          </section>

          {error ? (
            <p className="inquiry-error" role="alert">
              {error}
            </p>
          ) : null}
          <p className="inquiry-privacy">{VENDOR_REGISTRATION_COPY.privacy}</p>
        </form>
      )}
    </InquiryFormLayout>
  )
}
